<template>
  <Grid
    gtr="auto auto 1fr"
    align-content="start"
    align-items="start"
    class="contact-card q-py-lg q-pl-xl q-pr-lg bg-white-1 shadow3 border-radius-sm"
  >
    <DotsIcon :popup-items="popupItems" @popup-item="$emit($event.name)" />

    <header class="flex items-center" style="gap: var(--r-space-md)">
      <RInitialsIcon :text="`${contact.first_name} ${contact.last_name || ''}`"></RInitialsIcon>

      <section>
        <div class="text-heading-1 text-secondary-1 ellipsis">
          {{ `${contact.first_name} ${contact.last_name || ''}` }}
        </div>
        <div v-if="!!primaryContact && primaryContact.id === contact.id" class="text-caption-1 text-grey3">
          Primary contact
        </div>
      </section>
    </header>

    <q-separator class="q-mt-md" />

    <div class="content full-height overflow-auto">
      <BasicInfo :contact="contact" class="q-mt-sm" />
      <EmailPreferences :initial-preferences="contact.email_preferences" class="q-mt-lg" />
      <Notes
        edit-mode
        :grouped="false"
        :entity="{ name: 'contact', id: contact.id }"
        :fill-vertical-space="true"
        store-namespace="contacts"
        class="q-mt-lg"
      >
        <template #title>
          <div class="text-body-3 text-secondary-1">Notes</div>
        </template>
      </Notes>
    </div>
  </Grid>
</template>

<script>
// Libraries
import { mapGetters } from 'vuex'
// Components
import RInitialsIcon from '@/ui/RInitialsIcon'
import DotsIcon from '@/ui/icons/DotsIcon'
import Notes from '@components/lm-blocks/Notes.vue'
import BasicInfo from './BasicInfo'
import EmailPreferences from './EmailPreferences'

export default {
  components: {
    RInitialsIcon,
    DotsIcon,
    Notes,
    BasicInfo,
    EmailPreferences
  },

  props: {
    contact: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters('provider-show', ['primaryContact']),

    popupItems() {
      return [
        { name: 'edit', label: 'Edit' },
        { name: 'delete', label: 'Delete', textColorClass: 'text-danger-1' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.contact-card {
  min-width: var(--card-width);
  height: var(--card-height);

  position: relative;

  .dots-icon {
    position: absolute;
    top: var(--r-space-md);
    right: var(--r-space-md);
  }

  .q-separator {
    background: var(--r-white-4);
  }

  .content {
    margin-right: calc(var(--r-space-lg) * -1);
    padding-right: var(--r-space-lg);
  }

  .notes {
    padding: revert;
    border-radius: revert;
    box-shadow: revert;
  }
}
</style>
